var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRing1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 188,
    viewBox: "0 0 223 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.05
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 163C196.026 163 245 113.027 245 52C245 -9.02713 196.026 -59 135 -59C73.9738 -59 25 -9.02713 25 52C25 113.027 73.9738 163 135 163Z",
    stroke: "#516CD3",
    strokeWidth: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing1);
export default __webpack_public_path__ + "static/media/Ring1.386d2ab1ff5465d1c9cd22ec3c2f9eeb.svg";
export { ForwardRef as ReactComponent };